import React from 'react';
import ViewPT from '../../components/ViewProducts';

function Home() {
    return (
        <ViewPT ></ViewPT>
    )

}

export default Home;